import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LinkColor } from '@freelancer/ui/link';
import { PaymentShareTeamInfo } from 'app/payments/payment-methods/payment-methods.types';

@Component({
  standalone: false,
  selector: 'app-payment-method-details',
  template: `
    <p class="font-bold">
      {{ label }}
      @if (currency) {
        ({{ currency }})
      }
    </p>

    @if (!team) {
      <p>#{{ token }}</p>
    } @else {
      @if (team.isTeamOwner) {
        <div class="PaymentMethod-paymentSharingDetails">
          <fl-icon
            class="mr-xxxsmall"
            [name]="'ui-group-outline'"
            [useIconFont]="true"
            [fillIconFont]="true"
          ></fl-icon>
          <span class="text-foreground text-body-16">
            {{ team.name }}
          </span>
        </div>
      } @else {
        @if (team.ownerUsername) {
          <p i18n="Payment Sharing Team Owner">
            Owned by {{ team.ownerUsername }} (<fl-link
              flTrackingLabel="PaymentSharingTeamOwnerProfileLink"
              [color]="LinkColor.INHERIT"
              [link]="'/u/' + team.ownerUsername"
              >&#64;{{ team.ownerUsername }}</fl-link
            >)
          </p>
        } @else {
          <fl-loading-text
            [padded]="false"
            [rows]="1"
          ></fl-loading-text>
        }
      }
    }
  `,
  styleUrls: ['./payment-method-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentMethodDetailsComponent {
  LinkColor = LinkColor;

  @Input() label: string;
  @Input() currency?: string;
  @Input() token: string;
  @Input() team: PaymentShareTeamInfo;
}
